<template>
  <page>
    <profile-nav class="mb-3" v-if="isEnglishLang"/>
    <b-card no-body>
      <b-table class="user-sessions-table" :busy="$apollo.loading || !sessions" :items="sessions" :fields="fields" show-empty responsive>
        <template #empty>
          <div class="text-center my-2">
            There are no sessions (yet).
          </div>
        </template>
        <template #busy>
          <div class="text-center my-2">
            Loading...
          </div>
        </template>
        <template #cell(ipAddress)="{ value, item: { id } }">
          {{ value }}
          <b-badge v-if="id === currentSessionID" variant="success">Current</b-badge>
        </template>
        <template #cell(userAgent)="{ value: { browser, os, platform } }">
          <span class="userAgent-icons">
            <font-awesome-icon class="mr-2" :icon="[ browser.style, browser.name ]"/>
            <font-awesome-icon class="mr-2" :icon="[ os.style, os.name ]"/>
            <font-awesome-icon class="mr-2" :icon="[ platform.style, platform.name ]"/>
          </span>
        </template>
        <template #cell(opts)="{ item: { id } }">
          <b-btn v-if="id === currentSessionID" disabled size="sm" variant="danger" title="Log out to end this session">
            <font-awesome-icon icon="trash-alt"/>
          </b-btn>
          <b-btn v-else @click="() => endSession({ sessionID: id })" size="sm" variant="danger" title="End this session">
            <font-awesome-icon icon="trash-alt"/>
          </b-btn>
        </template>
      </b-table>
    </b-card>
  </page>
</template>

<script>
import gql from 'graphql-tag';
import formatDate from 'date-fns/format';
import Page from '@/components/Page';
import ProfileNav from '@/components/users/ProfileNav';
import UserSessionsQuery from '@/graphql/queries/UserSessions.gql';
import { faUserAgent } from 'fontawesome-user-agent';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    ProfileNav,
  },
  data: () => ({
    currentSessionID: null,
    selectedSessionID: null,
  }),
  metaInfo: {
    title: 'Your Sessions',
  },
  apollo: {
    sessions: {
      query: UserSessionsQuery,
      variables() {
        const { userID } = this;
        return { userID, where: { status: 'ACTIVE' } };
      },
      update: ({ company: { user: { sessions } } }) => sessions.filter(({ status }) => status === 'ACTIVE'),
      result({ loading, data }) {
        if (!loading && data) {
          const { id: currentSessionID = null } = data.currentSession || {};
          this.currentSessionID = currentSessionID;
        }
      },
      error(err) {
        this.$notifyFatalErr(err);
      },
      skip() {
        return !this.userID;
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'userID', 'isEnglishLang' ]),
    fields: () => ([
      { key: 'ipAddress', label: 'IP Address' },
      { key: 'userAgent', formatter: value => faUserAgent(value) },
      { key: 'created', label: 'Started', formatter: value => formatDate(value, 'DD/MM/YYYY HH:mm') },
      { key: 'updated', label: 'Last Accessed', formatter: value => formatDate(value, 'DD/MM/YYYY HH:mm') },
      { key: 'opts', label: '...', class: 'py-2' },
    ]),
  },
  methods: {
    // async updateUser({ avatar, ...update }) {
    //   const { userID } = this;
    //   this.formErr = null;
    //
    //   try {
    //     await this.$apollo.mutate({
    //       mutation: UserEditMutation,
    //       variables: { userID, update },
    //     });
    //
    //     this.$notification({
    //       title: 'Profile saved',
    //       message: 'Your account has been updated',
    //       variant: 'success',
    //     });
    //   } catch (err) {
    //     console.error(err);
    //     this.$notifyErr(err);
    //     throw err;
    //   }
    // },
    async endSession({ sessionID }) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation EndUserSession($sessionID: ID!) {
            updateUserSession(update: { status: INACTIVE }, where: { id: $sessionID }) {
              id
              status
            }
          }
        `,
        variables: {
          sessionID,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.user-sessions-table {
  .userAgent-icons {
    svg {
      width: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/EditSessions.vue